$(function () {
	$('.topSlider__slideWrap').slick({
		autoplay: true,
		arrows: false,
		dots: true,
		infinite: true
	});

});
